module.exports = require('./helpers/bundle-url').getBundleURL('7Zmw1') + "logo.c51670a8.svg";